<!--  -->
<template>
  <div class="FinancialReports">
    <div class="reports-main">
      <ul class="report-list">
        <li v-for="(item, index) in reportList" :key="index">
          <div class="list-box">
            <img :src="item.src" />
            <h1>{{ item.title }}</h1>
            <router-link :to="item.url">
              <div>{{ lookmore }}</div>
            </router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      lookmore: "", //查看更多
      reportList: [
        //     {
        //         id:"",
        //         title:"财务报告",
        //         src:require("../../assets/caiwubaogao.png"),
        //     },
        //     {
        //         id:"",
        //         title:"招股文件",
        //         src:require("../../assets/zhaoguwenjian.png"),
        //     },
      ],
    };
  },
  props: ["reportList"],
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.得到数据
    get_list() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 18,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.reportList.push({
                id: k.id,
                src: k.pic_f,
                title: k.title,
                url: k.url,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.lookmore = obj.data["ckgd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //this.get_list();
    this.get_fanyi();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.FinancialReports {
  width: 100%;
  margin-bottom: 85px;
  .reports-main {
    width: $main-width;
    margin: 0 auto;
    background: url("../../assets/reportBg.png");
    background-size: cover;
    padding-bottom: 85px;
    .report-list {
      display: flex;
      //   justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 30%;
        background: #fff;
        display: flex;
        flex-direction: column;
        margin: 20px;
        .list-box {
          width: auto;
          margin: 0 auto;
          padding: 30px 0 35px;
          text-align: center;
          h1 {
            margin: 30px 0 35px;
            font-size: 1.5rem;
            color: #2d2d2d;
          }
          div {
            width: 120px;
            padding: 4px 0;
            margin: 0 auto;
            border: 1px solid #0069b5;
            border-radius: 5px;
            text-align: center;
            color: #0069b5;
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .FinancialReports {
    .reports-main {
      width: 100%;
      .report-list {
        flex-direction: column;
        li {
          width: 90%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/investor/FinancialReports.vue